export default __webpack_public_path__ + "static/Market-d63d5629a034e6bef4d2b3ab2f7403d6.webp";